import { render, staticRenderFns } from "./CustomMessageDialog.vue?vue&type=template&id=baa3faa2&scoped=true"
import script from "./CustomMessageDialog.vue?vue&type=script&lang=js"
export * from "./CustomMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomMessageDialog.vue?vue&type=style&index=0&id=baa3faa2&prod&lang=scss&scoped=true"
import style1 from "./CustomMessageDialog.vue?vue&type=style&index=1&id=baa3faa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa3faa2",
  null
  
)

export default component.exports